<template>
    <template v-if="getUser()">
        <a :href="route('site.profile')" class="btn header__login-btn custom-btn">
            <span class="btn__icon icon-Profile"></span>
            <span class="btn__text">{{username}}</span>
        </a>
    </template>
    <template v-else>
        <a :href="route('site.login')" class="btn header__login-btn custom-btn">
            <span class="btn__icon icon-Profile"></span>
            <span class="btn__text">ورود به حساب کاربری</span>
        </a>
    </template>
</template>

<script>
export default {
    name: "HeaderProfile",
    computed: {
        username(){
            return this.getUser().name ?? this.getUser().mobile;
        }
    }
}
</script>

<style scoped>

</style>
